import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Container from 'components/container';
import { useStateValue } from 'context/store';
import { Input } from 'components/input';
import { ContactInfo, InputRow, InputColumn } from './elements';
import Button from 'components/button';
import { useWindowSize } from 'utils/hooks';
import PhoneNumber from 'components/phoneNumberInput';
import { addToLocalStorageObject } from 'utils/browserUtil';

function PersonalSettingsPage() {
  const { width } = useWindowSize();

  const token = JSON.parse(localStorage.getItem('userToken'));

  const {
    state: { user }
  } = useStateValue();

  const { currentUser } = user;
  const [form, setForm] = useState({
    firstName: {
      value: currentUser ? `${currentUser.first_name}` : '',
      error: ''
    },
    lastName: {
      value: currentUser ? `${currentUser.last_name}` : '',
      error: ''
    },
    email: {
      value: currentUser ? currentUser.email : '',
      error: ''
    },
    password: {
      value: '',
      error: ''
    },
    confirmPassword: {
      value: ''
    }
  });

  const [error, setError] = useState('');

  const { firstName, lastName, password, confirmPassword } = form;

  const comparePassword = password.value !== '' && confirmPassword.value !== '';

  const [phone, setPhone] = useState({
    number: currentUser ? currentUser.phone_number : ''
  });

  const accountPayload = {
    first_name: firstName.value,
    last_name: lastName.value,
    phone_number: phone.number,
    password: password.value,
    confirm_password: confirmPassword.value
  };

  const payload = JSON.stringify(accountPayload);

  function handleInputOnchange(evt) {
    setForm({
      ...form,
      [evt.target.id]: {
        value: evt.target.value,
        error: ''
      }
    });
  }

  function handleUpdateAccount(e) {
    e.preventDefault();
    if (password.value !== confirmPassword.value) {
      setError("Password Doesn't Match");
    }
    axios
      .patch(`${process.env.REACT_APP_API_URL}/users/user/${currentUser.id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'content-type': 'application/json'
        }
      })
      .then(({ data }) => {
        addToLocalStorageObject('user', data);
        window.location.reload();
      })
      .catch(err => console.error(err));
  }

  useEffect(() => {
    if (confirmPassword.value.length) {
      setError('');
    }
  }, [confirmPassword.value]);

  return (
    <Container>
      <ContactInfo
        style={error ? { paddingBottom: '20px' } : { paddingBottom: '0' }}
      >
        <h4>Contact Information</h4>
        <InputRow>
          <InputColumn>
            <Input
              onChange={handleInputOnchange}
              placeholder="First Name*"
              value={form.firstName.value}
              error={form.firstName.error}
              id="firstName"
            />
          </InputColumn>
          <InputColumn>
            <Input
              onChange={handleInputOnchange}
              placeholder="Last Name*"
              value={form.lastName.value}
              error={form.lastName.error}
              id="lastName"
            />
          </InputColumn>
        </InputRow>
        <InputRow>
          <InputColumn>
            <Input
              type="email"
              onChange={handleInputOnchange}
              placeholder="Email*"
              value={form.email.value}
              error={form.email.error}
              id="email"
            />
          </InputColumn>
          <InputColumn>
            <PhoneNumber
              id="Phone"
              defaultCountry={'ke'}
              number={phone.number}
              preferredCountries={[]}
              onChange={num => setPhone({ ...phone, number: num })}
            />
          </InputColumn>
        </InputRow>
        <InputRow>
          <InputColumn>
            <Input
              onChange={handleInputOnchange}
              placeholder="Password*"
              value={form.password.value}
              error={form.password.error}
              id="password"
              type="password"
              required
              autocomplete="off"
            />
          </InputColumn>
          <InputColumn>
            <Input
              onChange={handleInputOnchange}
              placeholder="Confirm Password*"
              value={form.confirmPassword.value}
              error={error}
              id="confirmPassword"
              type="password"
              autocomplete="off"
            />
          </InputColumn>
        </InputRow>
      </ContactInfo>
      <Button
        onClick={handleUpdateAccount}
        disabled={comparePassword === false}
        style={width > 768 ? { float: 'right' } : { marginBottom: 28 }}
        width={width > 768 ? '288px' : '100%'}
        color="yellow"
      >
        SAVE CHANGES
      </Button>
    </Container>
  );
}

export default PersonalSettingsPage;
